/**
 * Resolves the next DictionarySelect value.
 * - Custom dictionaries may be freely toggled.
 * - At least one language dictionary is always required.
 * - When multi language select is off, only one language dictionary may be selected.
 */
export const applyDictionarySelection = (
  nextValues: string[],
  previousValues: string[],
  languageDictionaryValues: ReadonlySet<string>,
  allowMultipleLanguageDictionaries: boolean,
): string[] => {
  const nextCustom: string[] = [];
  const nextLanguage: string[] = [];

  for (const value of nextValues) {
    if (languageDictionaryValues.has(value)) {
      nextLanguage.push(value);
    } else {
      nextCustom.push(value);
    }
  }

  let resolvedLanguage = nextLanguage;

  if (!allowMultipleLanguageDictionaries && nextLanguage.length > 1) {
    const newlySelected = nextLanguage.find((value) => !previousValues.includes(value));
    resolvedLanguage = newlySelected ? [newlySelected] : [nextLanguage[nextLanguage.length - 1]];
  }

  if (resolvedLanguage.length === 0) {
    const previousLanguage: string[] = [];
    for (const value of previousValues) {
      if (languageDictionaryValues.has(value)) {
        previousLanguage.push(value);
      }
    }
    resolvedLanguage = previousLanguage;
  }

  return [...resolvedLanguage, ...nextCustom];
};
